import React from 'react';
import styled from 'styled-components';

export default function PlayerButton({image, alt, onClick}) {
    return (
        <Container onClick={onClick}>
            <Image src={image} alt={alt} />
        </Container>
    );
}

const Container = styled.div`
    width: 46px;
    height: 40px;
    background-color: black;
    border-radius: 6px;
    opacity: 0.65;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;

const Image = styled.img`
    height: 28px !important;
`;
